import { Star } from "lucide-react";

export const TestimonialCard = ({ t, className = "" }) => (
  <figure className={`card-soft p-7 w-[320px] sm:w-[360px] shrink-0 flex flex-col ${className}`}>
    <div className="flex gap-1 mb-4" aria-label={`${t.stars} out of 5 stars`}>
      {Array.from({ length: t.stars }).map((_, i) => (
        <Star key={i} className="w-4 h-4 fill-gold text-gold" strokeWidth={1} />
      ))}
    </div>
    <blockquote className="font-serif text-[1.05rem] text-ink leading-relaxed italic flex-1">"{t.quote}"</blockquote>
    <figcaption className="mt-5 pt-4 border-t border-ink/[0.07]">
      <p className="text-sm font-semibold text-ink">{t.name}</p>
      <p className="text-xs text-ink-muted mt-1">{t.context}</p>
    </figcaption>
  </figure>
);

export default function TestimonialMarquee({ testimonials }) {
  const row = testimonials.map((t, i) => <TestimonialCard key={i} t={t} className="mr-6" />);
  return (
    <div className="overflow-hidden marquee-paused" data-testid="testimonial-marquee">
      <div className="marquee-track marquee-slow py-2">
        {row}
        {row.map((card, i) => ({ ...card, key: `dup-${i}` }))}
      </div>
    </div>
  );
}
